import type {Dayjs} from 'dayjs'
import type {Workdays} from '@package/shared'
import type {DateRange} from '../../../components/dateRangeSelector/DateRangeSelector.tsx'

export const mapWorkdayDateRange = (day: Dayjs, workdays: Workdays): DateRange | undefined => {
  const workday = workdays[day.day()] || undefined
  if (!workday) return undefined

  const firstTimeRange = workday.at(0)
  const lastTimeRange = workday.at(-1)
  if (!firstTimeRange || !lastTimeRange) return undefined

  const [startHour, startMinute] = firstTimeRange.start.split(':').map((part) => Number.parseInt(part))
  const [endHour, endtMinute] = lastTimeRange.end.split(':').map((part) => Number.parseInt(part))

  return {
    start: day.set('hour', startHour).set('minute', startMinute).startOf('minute'),
    end: day.set('hour', endHour).set('minute', endtMinute).startOf('minute'),
  }
}
